module.exports = __webpack_public_path__ + "static/img/kefu_pic.fb663983.png";